export const ReceiveIcon = props => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_5875_20481"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect x="0.5" y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5875_20481)">
      <path
        d="M10.4958 13.1875C10.3958 13.1875 10.3021 13.1701 10.2146 13.1354C10.1271 13.1007 10.0486 13.0486 9.97917 12.9792L7.02083 10.0208C6.86806 9.86931 6.79514 9.69257 6.80208 9.49062C6.80903 9.28854 6.88556 9.11111 7.03167 8.95833C7.19111 8.80556 7.37153 8.72917 7.57292 8.72917C7.77431 8.72917 7.95139 8.80556 8.10417 8.95833L9.75 10.625V4.25C9.75 4.0375 9.82146 3.85937 9.96438 3.71562C10.1073 3.57187 10.2844 3.5 10.4956 3.5C10.7069 3.5 10.8854 3.57187 11.0312 3.71562C11.1771 3.85937 11.25 4.0375 11.25 4.25V10.625L12.9167 8.95833C13.0649 8.80556 13.2408 8.73264 13.4444 8.73958C13.6481 8.74653 13.8297 8.82639 13.9892 8.97917C14.1353 9.13194 14.2083 9.30903 14.2083 9.51042C14.2083 9.71181 14.1319 9.88889 13.9792 10.0417L11.0208 12.9792C10.9458 13.0486 10.8646 13.1007 10.7771 13.1354C10.6896 13.1701 10.5958 13.1875 10.4958 13.1875ZM5.99417 16.5C5.58139 16.5 5.22917 16.3531 4.9375 16.0594C4.64583 15.7656 4.5 15.4125 4.5 15V14.25C4.5 14.0375 4.57146 13.8594 4.71437 13.7156C4.85729 13.5719 5.03437 13.5 5.24562 13.5C5.45687 13.5 5.63542 13.5719 5.78125 13.7156C5.92708 13.8594 6 14.0375 6 14.25V15H15V14.25C15 14.0375 15.0715 13.8594 15.2144 13.7156C15.3573 13.5719 15.5344 13.5 15.7456 13.5C15.9569 13.5 16.1354 13.5719 16.2812 13.7156C16.4271 13.8594 16.5 14.0375 16.5 14.25V15C16.5 15.4125 16.3531 15.7656 16.0592 16.0594C15.7653 16.3531 15.4119 16.5 14.9992 16.5H5.99417Z"
        fill="#5663F2"
      />
    </g>
  </svg>
);
